/**
 * Documents de l'entreprise (15/10/2026) : chacun les lit ; la saisie reste à
 * qui gère les paramètres (contrôlé par la page et par l'API).
 */
import { lazy } from 'react';
import type { AppRoute, RouteGate } from '../../app/route-types.js';

const CompanyDocumentsPage = lazy(() => import('./CompanyDocumentsPage.js').then((m) => ({ default: m.CompanyDocumentsPage })));
const CompanyDocumentPage = lazy(() => import('./CompanyDocumentPage.js').then((m) => ({ default: m.CompanyDocumentPage })));
const CompanyDocumentFormPage = lazy(() => import('./CompanyDocumentFormPage.js').then((m) => ({ default: m.CompanyDocumentFormPage })));

const manage: RouteGate = { anyOf: ['settings.manage'] };

export const companyDocumentsRoutes: AppRoute[] = [
  { path: '/entreprise/documents', element: <CompanyDocumentsPage /> },
  { path: '/entreprise/documents/nouveau', element: <CompanyDocumentFormPage />, gate: manage },
  { path: '/entreprise/documents/:id', element: <CompanyDocumentPage /> },
  { path: '/entreprise/documents/:id/modifier', element: <CompanyDocumentFormPage />, gate: manage },
];
